export default function BrandMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
      <rect width="40" height="40" rx="3" fill="#0369a1" />
      <path d="M11 30 L20 9 L29 30" stroke="#ffffff" strokeWidth="3" fill="none" strokeLinejoin="round" strokeLinecap="round" />
      <path d="M14 23 C17 19, 23 19, 26 23" stroke="#7dd3fc" strokeWidth="2.2" fill="none" strokeLinecap="round" />
      <path d="M15.5 27 C18 24, 22 24, 24.5 27" stroke="#7dd3fc" strokeWidth="2.2" fill="none" strokeLinecap="round" />
    </svg>
  );
}
